import React, { useState } from "react";
import { connect } from "react-redux";
import useEmpresa from "../../../hooks/useEmpresa";
import { formatearMontoPesos } from "../../../utils/CurrencyUtil";
import IngresoActions from "../../../stores/ingreso/Actions";
import { useMountEffect } from "../../../hooks/LifeCycle";
import Spinner from "../../../components/Common/Spinner";
import CheckRender from "../../../components/Common/CheckRender";

const VoucherHonorariosScreen = (props) => {
  const {
    formCierreCuentasData,
    authUserData,
    consultarDetalleCierreCuentaLoading,
  } = props;

  const empresa = useEmpresa();

  const [isVoucherMatricial, setIsVoucherMatricial] = useState(false);
  const [codigoReclamante, setCodigoReclamante] = useState(0);

  useMountEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isMatricial = urlParams.get("isMatricial");
    const numeroIngreso = urlParams.get("numeroIngreso");
    const anioIngreso = urlParams.get("anioIngreso");
    const codigoReclamante = Number(urlParams.get("codigoReclamante"));

    setIsVoucherMatricial(isMatricial?.toLowerCase() === "true");
    setCodigoReclamante(codigoReclamante);

    props.consultarDetalleCierreCuenta({
      numeroIngreso: numeroIngreso,
      anioIngreso: anioIngreso,
      compania: empresa?.CODIGO,
      reclamante: authUserData?.prestador,
      formCierreCuentasData,
      formHandler: props.formCierreCuentas,
    });
  });

  const getMontoTotalAutorizado = () => {
    return formCierreCuentasData?.medicosParticipantes
      ?.find(
        (medico) => Number(medico.codigoReclamante) === Number(codigoReclamante)
      )
      ?.honorarios?.reduce(
        (acumulador, procedimiento) =>
          Number(acumulador) + Number(procedimiento.montoAutorizado),
        0
      );
  };

  const getMontoTotalDiferencia = () => {
    return formCierreCuentasData?.medicosParticipantes
      ?.find(
        (medico) => Number(medico.codigoReclamante) === Number(codigoReclamante)
      )
      ?.honorarios?.reduce(
        (acumulador, procedimiento) =>
          Number(acumulador) + procedimiento.montoDiferencia,
        0
      );
  };

  return (
    <>
      <CheckRender allowed={consultarDetalleCierreCuentaLoading}>
        <Spinner size={20} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
      </CheckRender>
      <CheckRender allowed={!consultarDetalleCierreCuentaLoading}>
        <table
          width="227"
          border="0"
          cellspacing="1"
          cellpadding="2"
          style={{ fontSize: isVoucherMatricial ? "11px" : "9px" }}
        >
          <tr>
            <td colSpan="2" align="center">
              <img src={empresa?.LOGO_AZUL} width="134" alt="logo" />
            </td>
          </tr>
          <tr>
            <td colSpan="2" align="center">
              <b>Datos de reclamaci&oacute;n</b>
            </td>
          </tr>
          <tr>
            <td width="50%">No. Reclamaci&oacute;n</td>
            <td align="right">
              {
                formCierreCuentasData?.medicosParticipantes?.find(
                  (item) =>
                    Number(item.codigoReclamante) === Number(codigoReclamante)
                )?.reclamo
              }
            </td>
          </tr>
          <tr>
            <td>Fecha</td>
            <td align="right">{formCierreCuentasData?.fechaServicio}</td>
          </tr>
          <tr>
            <td colSpan="2">
              Sres.
              <br />
              <b>
                {
                  formCierreCuentasData?.medicosParticipantes?.find(
                    (item) =>
                      Number(item.codigoReclamante) === Number(codigoReclamante)
                  )?.nombreReclamante
                }
              </b>
            </td>
          </tr>
          <tr>
            <td>C&oacute;digo</td>
            <td>{codigoReclamante}</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td colSpan="2">
              <p>
                Autorizamos a suministrar a nuestro afiliado
                <br />
                {formCierreCuentasData?.nombreAfiliado}
              </p>
            </td>
          </tr>
          <tr>
            <td>Carnet No. </td>
            <td>{formCierreCuentasData?.codigoAsegurado}</td>
          </tr>
          <tr>
            <td>Documento No. </td>
            <td>{formCierreCuentasData?.cedula}</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
          </tr>
          <tr>
            <td>Plan</td>
            <td>{formCierreCuentasData?.plan}</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td align="right">&nbsp;</td>
          </tr>
          <tr>
            <td colSpan="2" align="left" valign="top">
              <table width="100%" border="0" cellspacing="1" cellpadding="2">
                {formCierreCuentasData?.medicosParticipantes
                  ?.find(
                    (medico) =>
                      Number(medico.codigoReclamante) ===
                      Number(codigoReclamante)
                  )
                  ?.honorarios?.map((procedimiento, index) => {
                    return (
                      <>
                        <tr>
                          <td colSpan="4">
                            <b>
                              {procedimiento?.nombreCobertura ||
                                procedimiento?.cobertura}
                            </b>
                          </td>
                        </tr>
                        <tr>
                          <td align="center">Cobert.</td>
                          <td align="center">Cant.</td>
                          <td align="center">ARS</td>
                          <td align="center">Afiliado</td>
                        </tr>
                        <tr>
                          <td align="center">{procedimiento?.cobertura}</td>
                          <td align="center">{procedimiento?.frecuencia}</td>
                          <td align="right">
                            {formatearMontoPesos(
                              String(procedimiento?.montoAutorizado)
                            )}
                          </td>
                          <td align="right">
                            {formatearMontoPesos(
                              String(procedimiento?.montoDiferencia)
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}

                <tr>
                  <td colSpan="2" align="right">
                    <b>Total:</b>{" "}
                  </td>
                  <td align="right">
                    <b>
                      {formatearMontoPesos(String(getMontoTotalAutorizado()))}
                    </b>
                  </td>
                  <td align="right">
                    <b>
                      {formatearMontoPesos(String(getMontoTotalDiferencia()))}
                    </b>
                  </td>
                </tr>
              </table>
              <p>&nbsp;</p>
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>Observaciones:</td>
                  <td></td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    Autorizo la revisi&oacute;n de mi expediente m&eacute;dico
                    al personal de Auditor&iacute;a M&eacute;dica designado por
                    <br />
                    Humano con el fin de evaluar integralmente la
                    atenci&oacute;n prestada.{" "}
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              </table>
              <table border="0" align="center" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="10" height="80" valign="bottom">
                    &nbsp;
                  </td>
                  <td valign="bottom">
                    <div align="center">
                      _________________________________ <br />
                      Firma del Afiliado
                    </div>
                  </td>
                  <td valign="bottom" width="10">
                    &nbsp;
                  </td>
                </tr>
                <tr>
                  <td width="10" height="80" valign="bottom">
                    &nbsp;
                  </td>
                  <td valign="bottom">
                    <div align="center">
                      _________________________________ <br />
                      Firma y Sello del Reclamante
                    </div>
                  </td>
                  <td valign="bottom" width="10">
                    &nbsp;
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </CheckRender>
    </>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  consultarDetalleCierreCuentaLoading:
    state.ingreso.consultarDetalleCierreCuentaLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  consultarDetalleCierreCuenta: IngresoActions.consultarDetalleCierreCuenta,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(VoucherHonorariosScreen);
